import { FCX } from "@datassential/platform-ui-lib";
import { IoIosArrowForward } from "react-icons/io";
import cn from "classnames";
import { useState } from "react";
import { FaLock } from "react-icons/fa";

const HomeSectionFooterLink: FCX<{
    url: string;
    text: string;
    altText?: string;
    hasAccess?: boolean;
    onContactUsClick: () => void;
}> = ({
    url,
    text,
    altText,
    hasAccess = true,
    onContactUsClick,
    className,
    style,
    testId,
}) => {
    const [isRequestSent, setIsRequestSent] = useState(false);


    return (
        <div
            className={cn('HomeSectionFooter__link', className)}
            style={style}
            data-testid={testId}
        >
            {isRequestSent && (<>
                Thank you for your request, we will get back to you shortly!
            </>)}
            {!isRequestSent && (<>
                {!hasAccess && <FaLock style={{ transform: 'translate(-3px, 2px)'}}/>}
                &nbsp;
                <a
                    href={url}
                    className={cn(
                        "HomeSectionFooter__link-anchor",
                        !hasAccess && "is-disabled"
                    )}
                >
                    {text}
                    <IoIosArrowForward className="HomeSectionFooter__link-icon"/>
                </a>
                <br/>
                {!hasAccess && (<>
                    {altText ?? text}
                    &nbsp;<a
                        href="#"
                        className="HomeSectionFooter__link-anchor is-underlined"
                        onClick={(e) => {
                            e.preventDefault();
                            onContactUsClick();
                            setIsRequestSent(true);
                        }}
                    >
                        Contact us
                    </a>
                    &nbsp;to learn more
                </>)}
            </>)}
        </div>
    );
};

export default HomeSectionFooterLink;